import { inject } from '@angular/core';
import { DevGuardService } from './dev-guard.service';

export const devGuard = () => {
    const devService = inject(DevGuardService);

    return devService.canActivate();
};
